"use strict";

import "youboralib";
import "youbora-adapter-videojs5";

( function( namespace ) {
	var youboraLoaded = false;

	namespace.loadYoubora = function( el, player ) {
		if ( youboraLoaded ) {
			return;
		}

		youboraLoaded = true;

		var youbora = require( "youboralib" );
		youbora.adapters.Videojs5 = require( "youbora-adapter-videojs5" );

		var accCode = namespace.getYouboraAccCode();
		if ( !accCode ) {
			return;
		}

		var posterMedia = namespace.isPosterMedia( el );
		if ( !posterMedia ) {
			return;
		}

		var ybplugin = new youbora.Plugin( {
			accountCode: accCode,
			enableAnalytics: true,
			parseHLS: true,
			ads: {
				adsExpected: true,
			},
		} );
		if ( !ybplugin ) {
			videojs.log.error( player.id() + " youbora plugin initialization failed" );
			return;
		}

		if ( ybplugin && typeof youbora.adapters.Videojs5 !== "undefined" ) {
			var adapter = new youbora.adapters.Videojs5( player );
			ybplugin.setAdapter( adapter );

			videojs.log( player.id() + " youbora plugin initialized" );
		} else {
			videojs.log.error( player.id() + " youbora plugin not ready" );
		}
	};
} )( window.hearstLumierePlayer = window.hearstLumierePlayer || /* istanbul ignore next */ {} );



//////////////////
// WEBPACK FOOTER
// ./src/youbora.js
// module id = 124
// module chunks = 0